export default "__VITE_ASSET__C$Cy32DW__"